import styled from "styled-components";

export const FooterWrapper = styled.div`
  padding: 40px 160px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  background-color: #f8f9fa;

  > div:first-child {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 15px;
    line-height: 22px;
    gap: 24px;
    flex: 1;

    > span {
      color: #1b1b1b;

      b {
        font-size: 18px;
        color: var(--portal-secondary);
        display: block;
        margin-bottom: 8px;
      }
    }
  }

  @media(max-width: 960px) {
    padding: 24px 40px;

    > div:first-child {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
  }
`;

export const MediaButtonsContainer = styled.div`
  display: flex;
  flex-direction: row !important;
  gap: 12px;
  justify-content: flex-end;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center !important;
  }
`;

export const MediaButton = styled.a`
  border: none;
  background: var(--portal-secondary);
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s ease;

  svg {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background: var(--portal-primary);
    transform: translateY(-2px);
  }
`;

export const LogoImg = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;

  @media(max-width: 960px) {
    width: 60px;
    height: 60px;
  }
`;

export const FooterInfos = styled.div`
  background-color: var(--portal-secondary);
  padding-top: 24px;
  padding-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 160px;
  padding-left: 160px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 960px) {
    padding-left: 40px;
    padding-right: 40px;
    justify-content: center;
  }

  span {
    color: #fcfcfc;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    min-width: 200px;
  }

  > div {
    display: flex;
    gap: 8px;

    button {
      border: none;
      background: transparent;
      color: #fcfcfc;
      font-weight: 500;
      font-size: 15px;
      cursor: pointer;

      &: hover {
        color: var(--portal-primary);
      }
    }
  }
`;

export const SecuritySection = styled.div`
  background-color: #ffffff;
  padding: 16px 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 960px) {
    padding: 16px 40px;
    gap: 20px;
  }
`;

export const SecurityBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;

  svg {
    width: 24px;
    height: 24px;
  }

  span {
    font-size: 13px;
    font-weight: 600;
    color: #1b1b1b;
  }

  @media (max-width: 768px) {
    padding: 6px 12px;

    span {
      font-size: 12px;
    }
  }
`;

export const W3CBadge = styled.a`
  display: flex;
  align-items: center;
  transition: opacity 0.3s ease;
  text-decoration: none;

  img {
    height: 31px;
    width: auto;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const AccessibilityBadge = styled.a`
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  text-decoration: none;
  padding: 8px;
  border-radius: 8px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;

  img {
    height: 40px;
    width: auto;
  }

  &:hover {
    opacity: 0.8;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    padding: 6px;

    img {
      height: 35px;
    }
  }
`;

export const RadarBadge = styled.a`
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  text-decoration: none;
  padding: 4px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;

  img {
    height: 48px;
    width: auto;
  }

  &:hover {
    opacity: 0.8;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    padding: 3px;

    img {
      height: 42px;
    }
  }
`;
